import React from 'react';
import Tooltip from 'src/utils/Tooltip';
import Icon from './Icon';
import debounce from 'src/utils/debounce';
import { sendRequest } from 'src/utils/request';
import {ComponentConfigType} from "../../utils/ComponentConfigType";
import PromiseRequest from "../../utils/promise/PromiseRequest";

let labelRequestFilter: Record<string, any> = {}
let labelRequest: PromiseRequest<any>|undefined;
const labelFormats: Record<string, any> = {};
let labelComponents: Label[] = [];

const labelRequestLoader = debounce(() => {
    labelRequest && labelRequest.abort();
    labelRequest = sendRequest({
        option: "componentlist",
        component: "Documentation",
        itemsperpage: 0,
        filter: JSON.stringify({
            filters: Object.entries(labelRequestFilter).reduce((filters, [component, fields]) => {
                return [
                    ...filters,
                    fields.indexOf(null) !== -1 ? [
                        { field: "component", value: component },
                        { field: "field", value: "" }
                    ] : undefined,
                    fields.filter(Boolean).length > 0 ? [
                        { field: "component", value: component },
                        { field: "field", value: fields.filter(Boolean), operator: "in" }
                    ] : undefined
                ].filter(Boolean)
            }, []),
            operator: "or"
        })
    }, { showError: false });
    labelRequest.then((data) => {
        labelRequestFilter = {};
        data.items.forEach((item: any) => {
            labelFormats[[item.component, item.field].filter(Boolean).join(".")] = item.text;
        });
        labelComponents.map((comp) => {
            if (comp.mounted) {
                comp.forceUpdate();
            }
        });
    });
}, 300);

export type LabelPropsType = {
    componentConfig?: ComponentConfigType,
    name?: string,
    label?: any,
    required?: any,
    info?: any,
};

export default class Label extends React.Component<LabelPropsType> {

    mounted = false;

    load = () => {
        const component = this.props.componentConfig?.componentname ?? null;
        const field = this.props.name?.split?.(".")?.[0] ?? null;

        if (!component) return;

        if (!labelRequestFilter[component]) {
            labelRequestFilter[component] = [];
        }
        labelComponents.push(this);
        if (labelRequestFilter[component].indexOf(field) === -1) {
            labelRequest && labelRequest.abort();
            labelRequest = null;
            labelRequestFilter[component].push(field);
            labelRequestLoader();
        }
    }

    hasInfoProp = () => {
        if (this.props.info && this.props.info !== false && this.props?.info !== "" && this.props?.info !== null) {
            return true;
        }
        return false;
    }

    componentDidMount() {
        this.mounted = true;
        if (!this.hasInfoProp()) {
            this.load();
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    componentDidUpdate(prevProps: LabelPropsType) {
        if (!this.hasInfoProp() && (prevProps.name !== this.props.name || prevProps.componentConfig?.componentname !== this.props.componentConfig?.componentname)) {
            this.load();
        }
    }

    render() {

        const component = this.props.componentConfig?.componentname ?? null;
        const field = this.props.name?.split?.(".")?.[0] ?? null;
        const infoContent = labelFormats?.[[component, field].filter(Boolean).join(".")] ?? null;

        const style: Record<string, any> = {};
        if (this.props.label === false) {
            style.display = "none";
        }

        let tooltip = null;
        if (this.hasInfoProp()) {
            tooltip = <Tooltip title={<div dangerouslySetInnerHTML={{ __html: "<div>" + this.props.info + "</div>" }} />}><sup><Icon lib="fa" name="info-circle" /></sup></Tooltip>
        }
        else if (infoContent) {
            tooltip = <Tooltip title={<div dangerouslySetInnerHTML={{ __html: infoContent }} />}><sup><Icon lib="fa" name="info-circle" /></sup></Tooltip>
        }

        return (
            this.props.label !== false &&
            <label htmlFor={this.props.name} className="control-label" style={style}>
                {this.props.label}
                {tooltip}
                {this.props.required && <span className="invalid-feedback">*</span>}
            </label>
        )
    }
}